import { useEffect, useState, useRef } from 'react';
import { io } from 'socket.io-client';

export default function SensorWebSocket({ serial, onMessages }) {
    const socketRef = useRef(null);

    useEffect(() => {
        if (!serial) return;

        // Connect to your Flask-SocketIO backend
        // ws needs to be here in path and not the env variable; otherwise React (socket.io) will add something else on its own...
        socketRef.current = io(process.env.REACT_APP_WEBSOCKET, {
            path: '/ws',              // must match Flask `path`
            transports: ['websocket'],    // ensure it uses WebSocket directly
        });

        const socket = socketRef.current;

        socket.on('connect', () => {
            console.log('Socket.IO connected');
            // Optional: tell backend which device you want to subscribe to
            socket.emit('subscribe', { serial });
        });

        socket.on('disconnect', () => {
            console.log('Socket.IO disconnected');
        });

        // Handle messages sent from backend
        socket.on('server_message', (msg) => {
            if (msg.serial === serial) {
                onMessages(msg);
            }
        });

        return () => {
            if (socket.connected) {
                socket.emit('unsubscribe', { serial });
                socket.disconnect();
            }
        };
    }, [serial]);

    return null;
}
